import { MicrositeTemplate } from '~/model';
import { useRegisterSection } from '~/hooks/useSections';
import MapBlockAlpha from '~/editor/templates/alpha/MapBlockAlpha';
import MapBlockBeta from '~/editor/templates/beta/MapBlockBeta';
import MapBlockDelta from '~/editor/templates/delta/MapBlockDelta';
import MapBlockEpsilon from '~/editor/templates/epsilon/MapBlockEpsilon';
import MapBlockEta from '~/editor/templates/eta/MapBlockEta';
import MapBlockZeta from '~/editor/templates/zeta/MapBlockZeta';
import { type ComponentConfig } from '@puckeditor/core';
import { DEMO_ADDRESS, DEMO_MAP } from '~/demo';

export interface MapBlockProps {
	navigation?: boolean;
	template: MicrositeTemplate;
}

export const PUCK_BLOCK_MAP: ComponentConfig<MapBlockProps> = {
	label: 'Map',
	fields: {
		navigation: {
			type: 'radio',
			options: [
				{ label: 'On', value: true },
				{ label: 'Off', value: false },
			],
		},
		template: {
			type: 'radio',
			options: [
				{ label: 'Alpha', value: MicrositeTemplate.ALPHA },
				{ label: 'Beta', value: MicrositeTemplate.BETA },
				{ label: 'Delta', value: MicrositeTemplate.DELTA },
				{ label: 'Epsilon', value: MicrositeTemplate.EPSILON },
				{ label: 'Eta', value: MicrositeTemplate.ETA },
				{ label: 'Zeta', value: MicrositeTemplate.ZETA },
			],
		},
	},
	defaultProps: {
		navigation: true,
		template: MicrositeTemplate.ETA,
	},
	permissions: {
		duplicate: false,
	},
	render(props) {
		return <MapBlock {...props} />;
	},
};

export default function MapBlock({ navigation = true, template }: MapBlockProps) {
	const id = useRegisterSection('map', 'Map', navigation);

	let content = <></>;

	if (template === MicrositeTemplate.ALPHA) {
		content = <MapBlockAlpha street={DEMO_MAP} />;
	}
	if (template === MicrositeTemplate.BETA) {
		return <MapBlockBeta id={id} address={DEMO_ADDRESS} />;
	}
	if (template === MicrositeTemplate.DELTA) {
		content = <MapBlockDelta street={DEMO_MAP} />;
	}
	if (template === MicrositeTemplate.EPSILON) {
		content = <MapBlockEpsilon street={DEMO_MAP} />;
	}
	if (template === MicrositeTemplate.ETA) {
		content = <MapBlockEta street={DEMO_MAP} />;
	}
	if (template === MicrositeTemplate.ZETA) {
		content = <MapBlockZeta street={DEMO_MAP} />;
	}

	return <div id={id}>{content}</div>;
}
